/* stylelint-disable max-nesting-depth , selector-max-compound-selectors */
sew-ws-table {
    display: block;

    > p {
        @include typo-ws-paragraph-bold;

        margin: 0;
    }

    .open-button,
    .close-button,
    > p {
        display: none;
    }

    table {
        width: 100%;
        border-collapse: collapse;
        hyphens: auto;

        ul {
            list-style-type: square;
            margin: 0;
            padding-left: 20px;
        }
    }

    td {
        @include typo-ws-paragraph;

        padding: 16px 12px;
        vertical-align: text-top;
    }

    th {
        @include typo-ws-paragraph-bold;

        padding: 16px 12px;

        &:not([align]) {
            text-align: left;
        }
    }

    td,
    th {
        &.first-column {
            padding-left: 0;
        }
    }

    thead {
        th {
            padding-top: 0;
        }
    }

    .hidden-row {
        display: none;
    }

    .footer-wrapper {
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        align-items: flex-start;
    }

    .expand-button {
        all: unset;

        @include typo-ws-paragraph;

        margin-top: 16px;
        justify-self: end;
        display: flex;
        column-gap: 2px;
        cursor: pointer;
        color: $color-red;

        &.rows-unlimited {
            .svg {
                transform: rotateX(180deg);
            }
        }
    }

    tbody {
        tr {
            border-bottom: 1px solid $color-grey-04-middle;

            > tr:last-of-type {
                border-bottom: 0;
            }
        }

        > tr {
            &:first-of-type {
                border-top: 1px solid $color-grey-01-dark;
            }

            &.last-of-type,
            &:last-of-type {
                border-bottom: 1px solid $color-grey-01-dark;
            }
        }

        th + td {
            border-left: 1px solid $color-grey-01-dark;
        }

        td {
            &:not(.last-column) {
                border-right: 1px solid $color-grey-04-middle;
            }
        }

        th[rowspan] {
            border-right: 1px solid $color-grey-04-middle;
        }
    }

    footer {
        @include typo-ws-paragraph-s;

        padding-top: 8px;

        p {
            margin: 0;
        }
    }

    .sew-ws-table-wrapper {
        display: block;
        overflow: auto;
    }

    &[zebra] {
        tbody {
            > tr:nth-child(odd) {
                background: $color-grey-06-bright;
            }

            > tr > *:first-child {
                padding-left: 12px;
            }
        }
    }
}

@include mq-2-min {
    sew-ws-table {
        &[sticky] {
            thead {
                position: sticky;
                top: var(--header-height-scrolled);
                background: $color-white;
                z-index: 1;

                &::after {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    height: 1px;
                    background: $color-grey-01-dark;
                }

                th {
                    padding-top: 16px;
                }
            }

            .sew-ws-table-wrapper {
                overflow: visible;
            }
        }
    }
}

@include mq-2 {
    sew-ws-table {
        table {
            ul {
                padding-left: 15px;
            }
        }

        td {
            @include typo-ws-paragraph-s;
        }

        th {
            @include typo-ws-paragraph-s-bold;
        }
    }
}

@include mq-1 {
    sew-ws-table {
        > p {
            display: block;
            margin-top: 24px;
        }

        .open-button {
            border: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: $color-grey-05-light;
            width: 100%;
            padding: 32px 0 14px;
            margin-top: 20px;
            margin-bottom: 34px;
            cursor: pointer;

            span {
                @include typo-ws-paragraph-bold;

                margin: 12px 0 -2px;
            }

            .table-svg {
                align-self: center;
                display: block;
                color: $color-red;
                margin: -14px 0;
            }

            .arrow-svg {
                color: $color-red;
                transition: transform 300ms;

                .shaft {
                    transition: opacity 300ms;
                    opacity: 0;
                }
            }

            &:hover {
                .arrow-svg {
                    transform: translate3d(0, 8px, 0);

                    .shaft {
                        opacity: 1;
                    }
                }
            }
        }

        .close-button {
            all: unset;
            display: flex;
            color: $color-red;
            cursor: pointer;
            align-items: center;
            margin-bottom: 20px;
            margin-left: auto;

            span {
                @include typo-ws-paragraph;

                padding-right: 8px;
            }

            .close-svg {
                width: 20px;
                height: 20px;
                flex-shrink: 0;
            }
        }

        table {
            display: none;
        }

        footer {
            display: none;
        }

        .limit-rows {
            display: none;
        }
    }

    sew-ws-table.expanded {
        .open-button,
        > p {
            display: none;
        }

        table {
            display: table;
        }

        footer {
            display: block;
        }
    }
}
/* stylelint-enable max-nesting-depth , selector-max-compound-selectors */
